import { z } from "zod";

export const getEditRegionFormSchema = () => {
	return z.object({
		name: z.string().nullable().optional(),
		regionCode: z.string().max(10).nullable().optional(),
		isDeleted: z.boolean().nullable().optional(),
		timezone: z.string().nullable().optional(),
	});
};

export type EditRegionFormSchemaModel = z.infer<
	ReturnType<typeof getEditRegionFormSchema>
>;
